<template>
  <div class="ckeditor">
    <textarea :id="id" :value="value" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: 'editor',
    },
    height: {
      type: String,
      default: '200px',
    },
    language: {
      type: String,
      default: 'en',
    },
    extraplugins: {
      type: String,
      default: '',
    },
  },

  beforeUpdate() {
    const ckeditorId = this.id;
    if (this.value !== window.CKEDITOR.instances[ckeditorId].getData()) {
      window.CKEDITOR.instances[ckeditorId].setData(this.value);
    }
  },

  mounted() {
    const ckeditorId = this.id;

    window.CKEDITOR.plugins.addExternal('brclear', '/static/js/ckeditor/plugins/brclear/plugin.js');

    window.CKEDITOR.replace(ckeditorId, {
      language: 'en',

      toolbar: [
        { name: 'clipboard', items: ['Undo', 'Redo'] },
        { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
        { name: 'colors', items: ['TextColor', 'BGColor'] },
        { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'brclear'] },
        '/',
        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] },
        { name: 'links', items: ['Link', 'Unlink'] },
        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
        { name: 'insert', items: ['Image', 'Table', 'HorizontalRule'] },
        { name: 'tools', items: ['Maximize'] },
        { name: 'editing', items: ['Scayt'] },
        { name: 'document', items: ['Source'] },
      ],

      extraAllowedContent: 'h3{clear};h2{line-height};h2 h3{margin-left,margin-top};*{clear}',

      // Adding drag and drop image upload.
      extraPlugins: 'format,font,colorbutton,justify,uploadimage,brclear',
      uploadUrl: '/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',

      // Configure your file manager integration. This example uses CKFinder 3 for PHP.
      // filebrowserBrowseUrl: '/ckfinder/ckfinder.html',
      // filebrowserImageBrowseUrl: '/ckfinder/ckfinder.html?type=Images',
      filebrowserUploadUrl: `${this.$config.app_api.host}wysiwyg/upload-image`,
      // filebrowserUploadUrl: '/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files',
      // filebrowserImageUploadUrl: '/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images',
      // filebrowserImageUploadUrl: 'http://127.0.0.1/wysiwyg/upload-image',

      height: this.height,
    });

    window.CKEDITOR.instances[ckeditorId].setData(this.value);

    window.CKEDITOR.instances[ckeditorId].on('change', () => {
      const ckeditorData = window.CKEDITOR.instances[ckeditorId].getData();
      if (ckeditorData !== this.value) {
        this.$emit('input', ckeditorData);
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// Ckeditor.vue?651e4fc4